module.exports = __webpack_public_path__ + "assets/DropPerpDetailed.80a2af1f5b9bcb96fcc4c0def44dd113.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/DropPerpDetailed.png
// module id = 503
// module chunks = 0